/** Attachments a chat message can carry; the server enforces the same cap. */
export const MAX_ATTACHMENTS = 10

/** Which of `incoming` fit into the free slots left by `current`, and how many were dropped. */
export function planAttachmentAdd(current: number, incoming: number): { accepted: number; dropped: number } {
  const accepted = Math.max(0, Math.min(incoming, MAX_ATTACHMENTS - current))
  return { accepted, dropped: Math.max(0, incoming - accepted) }
}

const EXT_BY_MIME: Record<string, string> = {
  'image/png': 'png',
  'image/jpeg': 'jpg',
  'image/gif': 'gif',
  'image/webp': 'webp'
}

/** Images pasted from the clipboard arrive nameless; give them a stable, unique name. */
export function pastedFileName(mime: string, stamp: number): string {
  const ext = EXT_BY_MIME[mime] ?? 'png'
  return `pasted-${stamp}.${ext}`
}

/** Only images are pasted from the clipboard; other clipboard files are ignored. */
export function isPastedImage(type: string): boolean {
  return type.startsWith('image/')
}
